import styled from "styled-components";
import {BulletListItem} from "@FRAMEWORK/ui/desktop/list";

const BulletList = styled.ul`
	margin-top: 10px;
	> li {
		font-size: var(--default-size);
		&::before {
			top: 10px;
		}
		@media print {
			font-size: 24px;
			&::before {
				top: 16px;
			}
		}
	}
	> li + li {
		margin-top: 5px;
	}
	+ p {
		display: block;
		margin-top: 10px;
	}
`;
const WarningText = styled.em`
	display: inline-block;
	color: var(--emp-color);
	&:not(:first-child) {
		margin-top: 20px;
	}

	@media print {
		font-size: 26px;
	}
`;

const Warning = () => (
	<>
		<WarningText>여행 시 주의사항</WarningText>
		<BulletList>
			<BulletListItem>
				여행 중 가이드의 안내사항 및 안전 수칙을 준수하여 주시기 바랍니다. 특히 현지 선택관광은 가이드의 주의사항을
				충분히 숙지하신 후 본인의 건강 상태를 고려하여 신중히 결정하시기 바랍니다.
			</BulletListItem>
			<BulletListItem>선택관광(옵션)은 현지 사정에 따라 진행이 불가하거나 변경될 수 있습니다.</BulletListItem>
			<BulletListItem>
				자유여행 및 자유시간 내 진행된 개별 일정으로 발생된 모든 안전사고/도난/질병 등의 사고의 책임은 여행자 본인에게
				있으니 주의하시기 바랍니다
			</BulletListItem>
			<BulletListItem>
				본 상품은 단체 패키지여행으로 운영되며, 여행자가 일정을 이탈하거나 행사 참여를 거부할 경우 발생하는 사고, 비용
				발생 등 모든 사항에 대해서 여행자 본인에게 책임이 있습니다.
			</BulletListItem>
			<BulletListItem>
				여행자 본인 건강이 원인인 사고와 본인의 과실로 인해 발생된 안전사고는 당사가 책임지지 않습니다.
			</BulletListItem>
			<BulletListItem>
				차량 내에서는 항시 안전벨트를 착용하시기를 바라며, 운행 중에는 절대로 좌석에서 일어나지 않습니다.
			</BulletListItem>
		</BulletList>
		<p>
			※ 여행 일정 중 발생할 수 있는 모든 안전사고에 유의하시기 바라며, 여행자 본인의 과실로 인한 안전사고는 본인이
			책임을 지게 되니 각별한 주의를 당부드립니다
		</p>
		<WarningText>임산부 주의사항 (출발일 기준)</WarningText>
		<BulletList>
			<BulletListItem>
				임산부의 경우 항공사마다 임신 주수에 따라 증빙서류 및 여행 가능 여부가 상이할 수 있습니다. 임산부가 있을 경우
				담당자에게 꼭 말씀해주세요.
			</BulletListItem>
			<BulletListItem>임신 24주 이상~32주 미만 : 영문 의사 진단 소견서 (최근 일주일 이내)</BulletListItem>
			<BulletListItem>임신 32주 이상 : 탑승 불가</BulletListItem>
		</BulletList>
	</>
);

export default Warning;
